// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"DietPop_ConfirmationPop__UGNhy","modalBody":"DietPop_modalBody__6A5eE"};